export enum FilterTypeEnum {
  Category = 'category',
  Favorite = 'favorite',
  Search = 'search',
}

export type GamesListState = {
  activeFilterType: FilterTypeEnum;
};
